const t=async t=>{try{const r=await fetch(t);if(!r.ok)throw new Error("Failed to fetch file");return await r.text()}catch(t){return console.error(t),""}};export{t as readTextFile};
//# sourceMappingURL=readTextFile.js.map
